import { onFCP } from 'web-vitals';

const firstContentfulPaint = (trackPerformanceMetricEvent) => {
  onFCP((metric) => {
    trackPerformanceMetricEvent({
      metric_name: 'first-contentful-paint',
      metric_type: 'web-vital',
      metric_value: metric.value,
    });
  });
};

export default firstContentfulPaint;
